import { Component, OnInit } from "@angular/core";
import { LayoutConfigModel } from "../../../interfaces/home/layout-config";

import * as objectPath from "object-path";

@Component({
  selector: "footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"]
})
export class FooterComponent implements OnInit {
  // Public properties
  config: LayoutConfigModel;
  today: number = Date.now();
  fluid: boolean;

  constructor() {}

  ngOnInit(): void {
    const config = JSON.parse(localStorage.getItem("layoutConfig"));

    // footer width fluid
    this.fluid = objectPath.get(config, "footer.self.width") === "fluid";
  }
}
